import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react';
import { hideFlashMessage } from '../../actions/ui';

const FlashMessage = ({ ...other }) => {
  const dispatch = useDispatch();
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    return () => {
      dispatch(hideFlashMessage());
    };
  }, [dispatch]);

  const message = useSelector(state => state.ui.flashMessage.message);
  const options = useSelector(state => state.ui.flashMessage.options);

  useEffect(() => {
    clearInterval(timerId);
    const duration = options?.duration || window.config.flashMessageDuration;
    if (duration) {
      setTimerId(
        setTimeout(() => {
          dispatch(hideFlashMessage());
        }, duration),
      );
    }

    return () => {
      clearInterval(timerId);
    };
  }, [dispatch, setTimerId, options]);

  return message ? (
    <MessageBar
      isMultiline={false}
      onDismiss={() => dispatch(hideFlashMessage())}
      dismissButtonAriaLabel="Dismiss"
      messageBarType={MessageBarType[options.type]}
      messageBarIconProps={{ iconName: options.type === 'error' ? 'Info' : 'CheckMark' }}
      role="alert"
      {...other}
    >
      {message}
    </MessageBar>
  ) : null;
};

export default FlashMessage;
